import { USERACCTRACKDETAILS } from './useracctrackdetails';

export class USERACCTRACKREQUEST {
   oldValue: USERACCTRACKDETAILS;
   newValue: USERACCTRACKDETAILS;
}
